import BasicTooltip from "../tooltips/BasicTooltip";
import { numberToStringFormat } from "./ControlUtils";
import { utils } from '../../utils';
/*
게시판 정보
    ManageId, BoardName, BoardType, NewYn, NewTerm, CommentYn, WriteRole, ReadRole, OrdYn, CreatedDate, CreatedBy

*/
export default function Columns4Manage (t)
{
    const columns = [
        {
            field: "RowNum",
            headerName: 'No.',
            flex: 0.3,
            type: 'number',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hide: false,
            sortable: false,
            resizable: false,
            editable: false,
        },
        {
            field: "ManageId",
            headerName: t('field.manageid'),
            flex: 0.5,
            type: 'string',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hide: false,
            sortable: false,
            resizable: false,
            editable: false,
        },
        {
            field: "BoardType",
            headerName: t('field.boardtype'),
            flex: 0.5,
            type: 'string',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hide: false,
            sortable: false,
            resizable: false,
            editable: false,
        },
        {
            field: "BoardName",
            headerName: t('field.boardname'),
            flex: 2,
            type: 'string',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'left',
            hide: false,
            sortable: false,
            resizable: false,
            editable: false,
            renderCell: (params) => (
                <BasicTooltip title={params.row.BoardName} placement="right-end" />
            ),
            valueGetter: ({ value }) => value || "-",
        },
        {
            field: "NewYn",
            headerName: t('field.newyn'),
            flex: 0.5,
            type: 'string',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hide: false,
            sortable: false,
            resizable: false,
            editable: false,
            //valueGetter: ({ value }) => value || "-",
        },
        {
            field: "NewTerm",
            headerName: t('field.newterm'),
            flex: 0.5,
            with: 0,
            type: 'number',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hide: false,
            sortable: false,
            resizable: false,
            editable: false,
            // valueGetter: params => params?.value === undefined || params?.value === null ? 0 : params?.value,
            valueFormatter: value => numberToStringFormat(value),
        },
        {
            field: "CommentYn",
            headerName: t('field.commentyn'),
            flex: 0.5,
            with: 0,
            type: 'string',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hide: false,
            sortable: false,
            resizable: false,
            editable: false,
            //valueGetter: ({ value }) => value || "-",
        },
        {
            field: "WriteRole",
            headerName: t('field.writerole'),
            flex: 0.5,
            with: 0,
            type: 'string',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hide: false,
            sortable: false,
            resizable: false,
            editable: false,
            //valueGetter: ({ value }) => value || "-",
            
        },
        {
            field: "ReadRole",
            headerName: t('field.readrole'),
            flex: 0.5,
            with: 0,
            type: 'string',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hide: true,
            sortable: false,
            resizable: false,
            editable: false,
            //valueGetter: ({ value }) => value || "-",
        },
        {
            field: "OrdYn",
            headerName: t('field.ordyn'),
            flex: 0.5,
            with: 0,
            type: 'string',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hide: true,
            sortable: false,
            resizable: false,
            editable: false,
            //valueGetter: ({ value }) => value || "-",
        },
        {
            field: "CreatedDate",
            headerName: t('field.createddate'),
            flex: 0.8,
            type: 'date',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            hideable: false,
            hide: false,
            sortable: false,
            resizable: false,
            editable: false,
            valueFormatter: (value) => utils.date.dateToString(value, "YYYY-MM-DD"),
        },
    ];

    return columns;
};